import React from "react";
import { useNavigate } from "react-router-dom";
import Fab from "../ui/Fab";

const AddPromitheia = () => {
  const navigate = useNavigate();
  return <Fab onClick={() => navigate("/ekkathariseis/new")} label="Νέα εκκαθάριση" />;
};

export default AddPromitheia;
